import { c as _c } from "react/compiler-runtime";
import { browserLogger } from '@newfront-insurance/dd-rum';
import { AuthOptions } from '@newfront-insurance/ms-graph-auth';
import { useCallback, useEffect, useState } from 'react';
import { msGraphManager } from '../../../services/ms-graph-manager';
import { useMSGraphAuth } from '../contexts/ms-graph-context';
export interface OutlookConnectController {
  // State
  outlookConnectEnabled: boolean;

  // Actions
  setOutlookConnectEnabled(enabled: boolean): void;
}
export function useOutlookConnectController(t0) {
  const $ = _c(29);
  const {
    msGraphEnabled,
    isChatVisible,
    notify
  } = t0;
  const msGraphAuth = useMSGraphAuth();
  const [outlookConnectEnabled, setOutlookConnectEnabledState] = useState(_temp);
  let t1;
  let t2;
  if ($[0] !== msGraphEnabled) {
    t1 = () => {
      msGraphManager.setFeatureFlagEnabled(msGraphEnabled);
    };
    t2 = [msGraphEnabled];
    $[0] = msGraphEnabled;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== msGraphAuth || $[4] !== msGraphEnabled) {
    t3 = () => {
      if (!msGraphEnabled && msGraphAuth && msGraphAuth.authState.state === AuthOptions.LOGGED_IN) {
        msGraphManager.disable();
        setOutlookConnectEnabledState(false);
      }
    };
    t4 = [msGraphEnabled, msGraphAuth];
    $[3] = msGraphAuth;
    $[4] = msGraphEnabled;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  const authStateValue = msGraphAuth?.authState.state;
  let t5;
  let t6;
  if ($[7] !== authStateValue || $[8] !== isChatVisible || $[9] !== msGraphAuth || $[10] !== notify || $[11] !== outlookConnectEnabled) {
    t5 = () => {
      if (isChatVisible && outlookConnectEnabled && msGraphAuth && (authStateValue === AuthOptions.LOGGED_OUT || authStateValue === AuthOptions.INTERACTION_REQUIRED)) {
        browserLogger.info("[NovaProvider] Nova opened with toggle ON but user logged out - triggering re-authentication", {
          authState: authStateValue
        });
        msGraphAuth.login().then(authState => {
          browserLogger.info("[NovaProvider] Re-authentication completed", {
            newAuthState: authState.state,
            wasSuccessful: authState.state === AuthOptions.LOGGED_IN
          });
          if (authState.state === AuthOptions.LOGGED_IN) {
            notify.success("Outlook connected successfully");
          }
        }).catch(_temp2);
      }
    };
    t6 = [isChatVisible, outlookConnectEnabled, authStateValue, msGraphAuth, notify];
    $[7] = authStateValue;
    $[8] = isChatVisible;
    $[9] = msGraphAuth;
    $[10] = notify;
    $[11] = outlookConnectEnabled;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      msGraphManager.disable();
      setOutlookConnectEnabledState(false);
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const disableOutlook = t7;
  let t8;
  if ($[15] !== notify) {
    t8 = () => {
      disableOutlook();
      notify.error("Outlook authentication was cancelled. Please enable again in Settings.");
    };
    $[15] = notify;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const handleAuthCancelled = t8;
  let t9;
  if ($[17] !== notify) {
    t9 = error_0 => {
      disableOutlook();
      notify.error(`Outlook authentication failed: ${error_0.message || "Please try again."}`);
    };
    $[17] = notify;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const handleAuthError = t9;
  let t10;
  if ($[19] !== handleAuthCancelled || $[20] !== handleAuthError || $[21] !== msGraphAuth || $[22] !== notify) {
    t10 = async () => {
      msGraphManager.enable();
      setOutlookConnectEnabledState(true);
      if (!msGraphAuth) {
        return;
      }
      const isLoggedIn = msGraphAuth.authState.state === AuthOptions.LOGGED_IN;
      if (isLoggedIn) {
        return;
      }
      ;
      try {
        const authState_0 = await msGraphAuth.login();
        if (authState_0.state === AuthOptions.LOGGED_IN) {
          notify.success("Outlook connected successfully");
        } else {
          handleAuthCancelled();
        }
      } catch (t11) {
        const error_1 = t11;
        handleAuthError(error_1 as Error);
      }
    };
    $[19] = handleAuthCancelled;
    $[20] = handleAuthError;
    $[21] = msGraphAuth;
    $[22] = notify;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const enableOutlook = t10;
  let t11;
  if ($[24] !== enableOutlook) {
    t11 = enabled => {
      if (enabled) {
        enableOutlook();
      } else {
        disableOutlook();
      }
    };
    $[24] = enableOutlook;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const setOutlookConnectEnabled = t11;
  let t12;
  if ($[26] !== outlookConnectEnabled || $[27] !== setOutlookConnectEnabled) {
    t12 = {
      outlookConnectEnabled,
      setOutlookConnectEnabled
    };
    $[26] = outlookConnectEnabled;
    $[27] = setOutlookConnectEnabled;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp2(error) {
  browserLogger.error("[NovaProvider] Re-authentication failed", error);
}
function _temp() {
  return msGraphManager.isEnabled();
}